import { Deserializable } from '../../protocols/deserializable';
import * as moment from 'moment';
import { EmploymentStatusType } from '../../types/dto/employment-status-type';
import { StatusReasonType } from '../../types/dto/status-reason-type';

export class EmploymentHistory implements Deserializable {
  id!: number;
  memberId!: number;
  employerId!: number | null;
  employer!: string;
  employmentStatusId!: number;
  employmentStatus!: EmploymentStatusType | null;
  statusChangeReasonId!: number | null;
  statusChangeReason!: StatusReasonType | null;
  startDate!: string;
  endDate!: string | null;

  // Not From API
  public formattedStartDate!: string;
  public formattedEndDate!: string | null;

  onDeserialize(): void {
    if (!!this.startDate) {
      const date = moment(this.startDate.split('T')[0]);
      this.formattedStartDate = date.format('DD / MM / YYYY');
    }
    if (!!this.endDate) {
      const date = moment(this.endDate.split('T')[0]);
      this.formattedEndDate = date.format('DD / MM / YYYY');
    }
    if (!!this.employmentStatus) {
      this.employmentStatus = window?.injector?.Deserialize?.instanceOf(EmploymentStatusType, this.employmentStatus);
    }
    if (!!this.statusChangeReason) {
      this.statusChangeReason = window?.injector?.Deserialize?.instanceOf(StatusReasonType, this.statusChangeReason);
    }
  }
}
